function pickName(row) {
  return row?.name ?? row?.Name ?? "";
}

function pickId(row) {
  return Number(row?.id ?? row?.Id);
}

/** Builds "City, State, Country" from a record with countryId/stateId/cityId. */
export function formatLocation(record, countries = [], states = [], cities = []) {
  if (!record) return "—";

  const countryId = Number(record.countryId ?? record.CountryId);
  const stateId = Number(record.stateId ?? record.StateId);
  const cityId = Number(record.cityId ?? record.CityId);

  const country = countries.find((c) => pickId(c) === countryId);
  const state = states.find((s) => pickId(s) === stateId);
  const city = cities.find((ci) => pickId(ci) === cityId);

  const parts = [pickName(city), pickName(state), pickName(country)].filter(Boolean);
  return parts.length ? parts.join(", ") : "—";
}
